import { LIGHT } from "../../shared/theme.js";
import { safeText } from "../../shared/formatters.js";
import { useClientContext } from "../../ClientContext.jsx";

interface SnapHistoryItem {
  period: string;
  label?: string;
  ref_date?: string;
}

interface PeriodSelectorProps {
  snapHistory: SnapHistoryItem[];
  selectedPeriod: string | null;
  onPeriodChange: (period: string) => void;
}

export default function PeriodSelector({
  snapHistory,
  selectedPeriod,
  onPeriodChange,
}: PeriodSelectorProps) {
  const { T } = useClientContext();

  if (snapHistory.length <= 1) return null;

  return (
    <div
      data-tour="period-selector"
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        padding: "8px 28px",
        background: T.card,
        borderBottom: `1px solid ${T.border}`,
        flexWrap: "wrap",
      }}
    >
      <span
        style={{
          fontSize: 11,
          color: T.sub,
          fontWeight: 600,
          textTransform: "uppercase",
          letterSpacing: "0.06em",
        }}
      >
        Visualizando:
      </span>
      {[{ period: "__latest__", label: "Mais recente" }, ...snapHistory.slice(0, 8)].map((h) => {
        const isSelected =
          selectedPeriod === null ? h.period === "__latest__" : selectedPeriod === h.period;
        return (
          <button
            key={h.period}
            onClick={() => onPeriodChange(h.period)}
            style={{
              padding: "4px 12px",
              borderRadius: 20,
              border: `1.5px solid ${isSelected ? T.accent : T.border}`,
              background: isSelected ? T.accent : "transparent",
              color: isSelected ? "#fff" : T.sub,
              fontSize: 12,
              fontWeight: isSelected ? 700 : 500,
              cursor: "pointer",
              transition: "all 0.15s",
            }}
          >
            {safeText(h.label || h.period, "history-period")}
          </button>
        );
      })}
    </div>
  );
}
